import { UPDATE_SPECIFIC_PARKING_DATA, RESET_SPECIFIC_PARKING_DATA } from "./specificParkingDataReducer"

export const updateSpecificParkingData = (data) => ({
    type: UPDATE_SPECIFIC_PARKING_DATA,
    payload: data
})

export const resetSpecificParkingData = () => ({
    type: RESET_SPECIFIC_PARKING_DATA,
})